var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Literal } from 'lincd/models';
import { linkedShape } from '../package.js';
import { literalProperty } from 'lincd/shapes/SHACL';
import { lincdForm } from '../ontologies/lincd-form.js';
import { xsd } from 'lincd-xsd/ontologies/xsd';
import { Thing } from 'lincd-schema/shapes/Thing';
import { rdf } from 'lincd/ontologies/rdf';
let InputField = class InputField extends Thing {
    get inputType() {
        return this.getValue(lincdForm.inputType);
    }
    set inputType(val) {
        this.overwrite(lincdForm.inputType, new Literal(val, rdf.type));
    }
    get description() {
        return this.getValue(lincdForm.description);
    }
    set description(val) {
        this.overwrite(lincdForm.description, new Literal(val, xsd.string));
    }
};
/**
 * indicates that instances of this shape need to have this rdf.type
 */
InputField.targetClass = lincdForm.InputField;
__decorate([
    literalProperty({
        path: lincdForm.inputType,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], InputField.prototype, "inputType", null);
__decorate([
    literalProperty({
        path: lincdForm.description,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], InputField.prototype, "description", null);
InputField = __decorate([
    linkedShape
], InputField);
export { InputField };
//# sourceMappingURL=InputField.js.map